import React, { useEffect, useState } from "react";
import { getIngestStatus } from "../lib/api";

export default function IngestionBanner() {
  const [status, setStatus] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function tick() {
      try {
        const s = await getIngestStatus();
        if (!cancelled) {
          setStatus(s);
          setErr(null);
        }
      } catch (e) {
        if (!cancelled) setErr(e?.response?.data?.detail || e.message);
      }
    }
    tick();
    const id = setInterval(tick, 3000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  if (!status && !err) return null;

  const phase = status?.status || "unknown";
  const years = status?.years_loaded?.join(", ") || status?.years_planned?.join(", ") || "—";
  const percent = Math.min(100, Math.max(0, status?.percent || 0));
  const counts = status?.counts || {};

  const bgClass =
    phase === "completed" ? "bg-emerald-50 border-emerald-200" :
    phase === "failed" ? "bg-red-50 border-red-200" :
    phase === "running" ? "bg-amber-50 border-amber-200" :
    "bg-zinc-50 border-zinc-200";

  return (
    <div
      data-testid="ingestion-status-banner"
      className={`w-full border-b ${bgClass} text-[12px] font-mono text-zinc-700`}
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex flex-wrap items-center gap-x-6 gap-y-1">
        <span className="font-semibold uppercase tracking-wider text-zinc-900" data-testid="ingest-phase">
          HCRIS Ingest · {phase}
        </span>
        <span data-testid="ingest-years">FY: {years}</span>
        {status?.latest_detected_year && (
          <span data-testid="ingest-latest-year">
            Latest detected: FY{status.latest_detected_year}
          </span>
        )}
        {phase === "running" && (
          <span className="flex items-center gap-2" data-testid="ingest-progress">
            <span className="inline-block w-32 h-1.5 bg-zinc-200 rounded-sm overflow-hidden">
              <span
                className="block h-full bg-emerald-600 transition-all"
                style={{ width: `${percent}%` }}
              />
            </span>
            <span>{percent}%</span>
            {status?.current_step && (
              <span className="text-zinc-500">· {status.current_step}</span>
            )}
          </span>
        )}
        {phase === "completed" && (
          <span className="text-zinc-600" data-testid="ingest-counts">
            reports={counts.reports || 0} · alpha={counts.alpha || 0} · nmrc={counts.nmrc || 0} · master={counts.hospital_master || 0}
          </span>
        )}
        {err && <span className="text-red-700">{err}</span>}
      </div>
    </div>
  );
}
